export default {
  container: {
    width: '100%',
    height: '100%'
  },
  buttonContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    margin: '20px 0px'
  },
  modalForm: {
    padding: 30
  }
};
